import { createFileRoute } from '@tanstack/react-router'

import { OrgImportPage } from '#/modules/system/org-import-page'

export const Route = createFileRoute('/_shell/import')({
  component: OrgImportPage,
})
